
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadside",
      function () {
        return require("private-next-pages/roadside/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadside"])
      });
    }
  